import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';

// Create the router instance
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  defaultViewTransition: true,
  scrollRestoration: true, // Disable default behavior
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
